import _typeof from "@babel/runtime/helpers/typeof";
import { useJsApiLoader } from '@react-google-maps/api';
import React from 'react';
import withConfig from "../../ComponentDependency/withConfig";
import { compose } from 'redux';
var css = {
  "map": "oalp-286ug"
};
import { withRouter } from "../../Helpers/withRouter";
import { withComponentDependency } from "../../ComponentDependency/withComponentDependency";
import { CustomMap } from "../../Components/Map/CustomMap";
import { defaultZoom } from "../../Helpers/map";
import DefaultMap from "../../Components/Map/DefaultMap";
import { InspectionCentreMap } from "../../Components/Map/InspectionCentreMap";
import { InspectionCityMap } from "../../Components/Map/InspectionCityMap";
var defaultStyle = {};
var ContainerStyle = {
  width: '100%',
  height: '100%'
};
export var MapWidget = function MapWidget(_ref) {
  var name = _ref.name,
    _ref$data = _ref.data,
    mapLocations = _ref$data.mapLocations,
    fallback = _ref$data.fallback,
    mapCenter = _ref$data.mapCenter,
    zoom = _ref$data.zoom,
    metadata = _ref.metadata,
    config = _ref.config;
  var _a, _b, _c, _d, _e;
  var _ref2 = metadata || {},
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? defaultStyle : _ref2$style;
  var staticAssetsHost = config.get('staticAssets');
  var siteCode = config.get('siteCode');
  var _useJsApiLoader = useJsApiLoader({
      googleMapsApiKey: config.get('gmaps', 'apiKey')
    }),
    isLoaded = _useJsApiLoader.isLoaded;
  if (!isLoaded) {
    return /*#__PURE__*/React.createElement(DefaultMap, {
      siteCode: siteCode,
      staticAssetsHost: staticAssetsHost
    });
  }
  if (!mapLocations || !Array.isArray(mapLocations) || !mapLocations.length) {
    return /*#__PURE__*/React.createElement(DefaultMap, {
      siteCode: siteCode,
      staticAssetsHost: staticAssetsHost
    });
  }
  if (!mapCenter || _typeof(mapCenter) !== 'object' || !mapCenter.lat || !mapCenter.lng) {
    return /*#__PURE__*/React.createElement(DefaultMap, {
      siteCode: siteCode,
      staticAssetsHost: staticAssetsHost
    });
  }
  if (!fallback || _typeof(fallback) !== 'object' || !fallback.mapCenter || !fallback.mapLocations || !Array.isArray(fallback.mapLocations) || !fallback.mapLocations.length || _typeof(fallback.mapCenter) !== 'object' || !fallback.mapCenter.lat || !fallback.mapCenter.lng) {
    return /*#__PURE__*/React.createElement(DefaultMap, {
      siteCode: siteCode,
      staticAssetsHost: staticAssetsHost
    });
  }
  if (typeof fallback.mapLocations === 'string') {
    return /*#__PURE__*/React.createElement(DefaultMap, {
      siteCode: siteCode,
      staticAssetsHost: staticAssetsHost
    });
  }
  var mapRevamp = (_a = metadata === null || metadata === void 0 ? void 0 : metadata.mapRevamp) !== null && _a !== void 0 ? _a : false;
  if (((_b = mapLocations === null || mapLocations === void 0 ? void 0 : mapLocations[0]) === null || _b === void 0 ? void 0 : _b.city) && mapRevamp) {
    var city = (_c = fallback === null || fallback === void 0 ? void 0 : fallback.mapLocations) === null || _c === void 0 ? void 0 : _c.find(function (location) {
      return location.name === mapLocations[0].city;
    });
    var baseUrl = "".concat(config.get('findOurStoresPath'), "/").concat(city === null || city === void 0 ? void 0 : city.name.toLowerCase(), "-").concat(city === null || city === void 0 ? void 0 : city.id);
    return /*#__PURE__*/React.createElement("div", {
      className: css.map,
      key: "".concat(name, "_map"),
      style: style
    }, /*#__PURE__*/React.createElement(InspectionCentreMap, {
      mapLocations: mapLocations,
      mapCenter: mapCenter,
      zoom: zoom || defaultZoom,
      containerStyle: ContainerStyle,
      staticAssetsHost: staticAssetsHost,
      siteCode: siteCode,
      baseUrl: baseUrl
    }));
  } else if (mapRevamp) {
    var _baseUrl = config.get('findOurStoresPath');
    if ((_d = fallback === null || fallback === void 0 ? void 0 : fallback.mapLocations) === null || _d === void 0 ? void 0 : _d.length) {
      return /*#__PURE__*/React.createElement("div", {
        className: css.map,
        key: "".concat(name, "_map"),
        style: style
      }, /*#__PURE__*/React.createElement(InspectionCityMap, {
        mapLocations: (_e = fallback === null || fallback === void 0 ? void 0 : fallback.mapLocations) !== null && _e !== void 0 ? _e : [],
        mapCenter: fallback === null || fallback === void 0 ? void 0 : fallback.mapCenter,
        zoom: (fallback === null || fallback === void 0 ? void 0 : fallback.zoom) || defaultZoom,
        containerStyle: ContainerStyle,
        staticAssetsHost: staticAssetsHost,
        siteCode: siteCode,
        baseUrl: _baseUrl
      }));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: css.map,
      key: "".concat(name, "_map"),
      style: style
    }, /*#__PURE__*/React.createElement(InspectionCityMap, {
      mapLocations: mapLocations,
      mapCenter: mapCenter,
      zoom: zoom || defaultZoom,
      containerStyle: ContainerStyle,
      staticAssetsHost: staticAssetsHost,
      siteCode: siteCode,
      baseUrl: _baseUrl
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: css.map,
    key: "".concat(name, "_map"),
    style: style
  }, /*#__PURE__*/React.createElement(CustomMap, {
    mapLocations: mapLocations,
    mapCenter: mapCenter,
    zoom: zoom || defaultZoom,
    containerStyle: ContainerStyle,
    staticAssetsHost: staticAssetsHost,
    siteCode: siteCode,
    fallback: fallback
  }));
};
export default compose(React.memo, withRouter, withComponentDependency, withConfig)(MapWidget);